export default {"src":"/_next/static/media/favcon-4.59b54ca4.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};